<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxSourceCell from "../../../../../../_shared/_modules/inbox-source-cell"
  import type {
    WrongRecipientSourceCleanupDraft,
    WrongRecipientSourceCleanupRow,
  } from "../../contract"
  let {
    row,
    disabled,
  }: InboxWorkflowCellProps<WrongRecipientSourceCleanupRow, WrongRecipientSourceCleanupDraft> =
    $props()
</script>
<InboxSourceCell label={row.sourceLabel} subLabel={row.sourceSubLabel} {disabled} />
